"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledImage = exports.StyledCard = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const react_lazy_load_image_component_1 = require("react-lazy-load-image-component");
require("react-lazy-load-image-component/src/effects/blur.css");
exports.StyledCard = styled_components_1.default.div `
  ${({ theme, direction = "column", link, margin }) => (0, styled_components_1.css) `
    overflow: visible;
    position: relative;
    z-index: 0;
    display: flex;
    flex: 1;
    flex-direction: ${direction};
    justify-content: space-between;
    box-sizing: border-box;
    border-radius: ${theme.border.radius.default * 8}px;
    background: ${bitcoincom_pkg_theme_1.colors.solid.white};
    margin: ${margin ? `${margin} ` : 0};
    box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    &::before {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      content: "";
      height: 100%;
      width: 100%;
      border-radius: ${theme.border.radius.default * 8}px;
    }
    ${link &&
    (0, styled_components_1.css) `
      text-decoration: none;
      cursor: pointer;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
    `}
  `}
`;
exports.StyledImage = (0, styled_components_1.default)(react_lazy_load_image_component_1.LazyLoadImage) `
  ${({ theme, direction = "column" }) => (0, styled_components_1.css) `
    width: 100%;
    max-height: 232px;
    object-fit: cover;
    border-top-left-radius: ${theme.border.radius.default * 8}px;
    border-top-right-radius: ${theme.border.radius.default * 8}px;
    ${direction === "row" &&
    (0, styled_components_1.css) `
      width: 30%;
      border-top-right-radius: 0px;
      max-height: none;
      border-bottom-left-radius: ${theme.border.radius.default * 8}px;
    `}
  `}
`;
exports.StyledContent = styled_components_1.default.div `
  ${({ theme, padded, centered, direction = "column", }) => (0, styled_components_1.css) `
    display: flex;
    flex: 1;
    flex-direction: ${direction};

    ${padded &&
    (0, styled_components_1.css) `
        padding: ${theme.spacing.unit * 2}px;

        ${bitcoincom_pkg_theme_1.media.sm `
          padding: ${theme.spacing.unit * 4}px ${theme.spacing.unit * 3}px;
        `}

        ${bitcoincom_pkg_theme_1.media.md `
          padding: ${theme.spacing.unit * 4}px ${theme.spacing.unit * 4}px;
        `}
      `}

    ${centered &&
    (0, styled_components_1.css) `
        align-items: center;
        text-align: center;
      `}

    ${direction === "row" &&
    (0, styled_components_1.css) `
        width: 70%;
      `}
  `}
`;
exports.default = {};
//# sourceMappingURL=styled.js.map